import { PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';

export const profileRequired = (postGroup: PostGroupsType, severity: ErrorMessageSeverity): PostEditorPostErrors => {
  const { profiles } = postGroup;
  return profiles.length
    ? false
    : {
        profileId: null,
        variationId: null,
        severity,
        selectedSocialProfiles: [],
        message: PostEditorValidationMessages.profileRequired
      };
};
